import React, { useState } from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper-bundle.css';

import Page from 'components/Page';
import AngleIcon from 'components/AngleIcon';

const swiperOptions = {
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    speed:    800,
};

const ProjectsTemplate = ({ page: { acf: { projects } } }) => {
    const [ swiper, setSwiper ] = useState(null);
    const [ isStart, setIsStart ] = useState(true);
    const [ isEnd, setIsEnd ] = useState(false);

    const handleFromEdge = () => {
        setIsStart(false);
        setIsEnd(false);
    };
    const handleReachBeginning = () => {
        setIsStart(true);
        setIsEnd(false);
    };
    const handleReachEnd = () => {
        setIsStart(false);
        setIsEnd(true);
    };

    return (
        <Page>
            <Inner>
                <Swiper
                    onSwiper={setSwiper}
                    onFromEdge={handleFromEdge}
                    onReachBeginning={handleReachBeginning}
                    onReachEnd={handleReachEnd}
                    {...swiperOptions}
                >
                    {projects.map((project, index) => (
                        <SwiperSlide key={index} style={{ width: '30%' }}>
                            <Project>
                                <ProjectTop>
                                    <ProjectImage src={project.image.sizes.medium_large} />
                                    <ProjectStatus className="h6" data-status={project.status}>{project.status}</ProjectStatus>
                                </ProjectTop>
                                <ProjectName>{project.name}</ProjectName>
                                <ProjectDescription className="content" dangerouslySetInnerHTML={{ __html: project.description }} />
                            </Project>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <NavContainer>
                    <PrevButton onClick={() => swiper && swiper.slidePrev()} $isStart={isStart}>
                        <AngleIcon/>
                    </PrevButton>
                    <NextButton onClick={() => swiper && swiper.slideNext()} $isEnd={isEnd}>
                        <AngleIcon flip/>
                    </NextButton>
                </NavContainer>
            </Inner>
        </Page>
    );
};


export default ProjectsTemplate;


const Inner = styled.div`
    padding: 5rem 3.5rem;
`;


const Project = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 0 1.5rem;
`;

const ProjectTop = styled.div`
    position: relative;
`;

const ProjectImage = styled.img`
    width: 100%;
    aspect-ratio: 10/9;
    object-fit: cover;
`;

const ProjectStatus = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    color: ${props => props.theme.primary_color};
    background-color: ${props => props.theme.secondary_color};
    padding: 1rem 1.5rem;

    &[data-status="Completed"] {
        color: ${props => props.theme.secondary_color_light};
        background-color: ${props => props.theme.primary_color};
    }
    
`;

const ProjectName = styled.h5`
    background: ${props => props.theme.gold_gradient};
    background-clip: text;
    color: transparent;
    text-transform: uppercase;
`;

const ProjectDescription = styled.div`

`;


const NavContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 4rem;
    margin-top: 3rem;
`;

const SliderButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    
    background: transparent;
    border: none !important;
    outline: none !important;
    cursor: pointer;
    padding: 0;
    
    color: ${props => props.theme.primary_color};
    line-height: 1;
    
    transition: opacity .45s;
    font-size: 2.5rem;
    
    opacity: .75;
    
    &:hover {
        opacity: 1;
    }
`;

const PrevButton = styled(SliderButton)`
    ${props => props.$isStart && `
        opacity: 0.4;
        cursor: default;
        pointer-events: none;
    `}
`;

const NextButton = styled(SliderButton)`    
    ${props => props.$isEnd && `
        opacity: 0.4;
        cursor: default;
        pointer-events: none;
    `}
`;